import React from 'react';
import TextField from './TextField';
import Select from './Select';
import Divider from './Divider';
import Heading from './Heading';
import Paragraph from './Paragraph';
import Checkbox from './Checkbox';
import ListBuilder from './ListBuilder';
import FormikListBuilder from './ListBuilder/variants/FormikListBuilder';
import FormikCheckbox from './Checkbox/variants/FormikCheckbox';
import FormikTextField from './TextField/variants/FormikTextField';
import FormikSelect from './Select/variants/FormikSelect';
import FormikDateField from './DateField/variants/FormikDateField';
import DateField from './DateField';

const formComponents = {
    TextField,
    FormikTextField,
    Select,
    FormikSelect,
    Divider,
    Heading,
    Paragraph,
    Checkbox,
    ListBuilder,
    FormikListBuilder,
    FormikCheckbox,
    FormikDateField,
    DateField,
};
export const getFormComponent = (name) => {
    const FormComponent = formComponents[name];
    if (FormComponent) return FormComponent;
};
